import React, { useEffect, useState } from "react";
import _ from "lodash";
import cx from "classnames";

import { useDispatch } from "react-redux";

import { AssessmentParameter, AssessmentSubParameter, Objectives, Simulation } from "src/types/coaching/simulation";
import { updateSimulationProperty } from "src/redux/actions/coaching/simulation";

import { ChatContainer } from "../chat";
import TextareaAutosize from "react-autosize-textarea";
import Button from "src/components/button";
import { AutoGrowInput, Input } from "src/components/input";
import { SimulationContext } from "../../context";

import styles from "./assessments.module.scss";
import { nanoid } from "nanoid";

interface AssessmentParameterEditorProps {
  simulation: Simulation;
  assessmentParameter: AssessmentParameter;
}

export const AssessmentParameterEditor: React.FC<AssessmentParameterEditorProps> = ({ simulation, assessmentParameter }) => {
  const dispatch = useDispatch();
  const simulationContext = React.useContext(SimulationContext);

  const persistedObjectives = simulation?.objectives;
  const [parameter, setParameter] = useState<AssessmentParameter | undefined>(assessmentParameter);


  useEffect(() => {
    setParameter(assessmentParameter);
  }, [assessmentParameter]);

  const handlePropertyChange = (property: string, value: any) => {
    // setParameter((prevObjectives) => {
    //   const updatedObjectives = {
    //     ...prevObjectives || {},
    //     [property]: value
    //   } as Objectives;
    //   return updatedObjectives;
    // });
  };

  const handleConfirm = () => {
    if (simulationContext.editAssessmentParameter) {
      simulationContext.editAssessmentParameter(null);
    }
  }

  const handleCancel = () => {
    if (simulationContext.editAssessmentParameter) {
      simulationContext.editAssessmentParameter(null);
    }
  }

  const handleGetParameters = () => {
    const parameters = {

    };

    return parameters;
  }

  const handleParametersChange = (parameters: any) => {
    _.keys(parameters).forEach((key) => {
      const value = parameters[key];
      if (value) {
        handlePropertyChange(key, value);
      }
    });
  }

  const handleAddSubParameter = () => {
    const newParameter = {
      uid: nanoid(6),
      name: "",
      criteria: "",
    } as AssessmentSubParameter;

    setParameter((prevParameter) => {
      const updatedParameter = {
        ...prevParameter,
        parameters: [...(prevParameter?.parameters || []), newParameter]
      } as AssessmentParameter;
      return updatedParameter;
    });
  }

  const handleDeleteSubParameter = (parameter: AssessmentSubParameter) => {
    setParameter((prevParameter) => {
      const updatedParameter = {
        ...prevParameter,
        parameters: prevParameter?.parameters?.filter((item) => item.uid !== parameter.uid)
      } as AssessmentParameter;
      return updatedParameter;
    });
  }

  return (
    <div className={styles.editor}>
      <div className={styles.header}>
        <div className={styles.title} onClick={handleCancel}>
          <button className={styles.backButton}>
            <i className={cx(styles.backIcon, 'paperflite-left-arrow')} />
          </button>
          <h2>Assessment</h2>
        </div>

        <div className={styles.actions}>
          <Button variant="gradient" className={cx(styles.action, styles.confirm)}
            icon="paperflite-tick" text="Confirm"
            onClick={handleConfirm} />
          <Button className={cx(styles.action, styles.cancel)}
            icon="paperflite-cancel"
            text="Cancel"
            onClick={handleCancel}
          />
        </div>
      </div>
      <p className={styles.description}>edit your selected template</p>

      <div className={styles.body}>
        <div className={cx(styles.left, styles.chat)}>
          <div className={styles.header}>
            <h4>Generate a parameter with seek</h4>
          </div>
          <div className={styles.chats}>
            <ChatContainer simulation={simulation}
              configurationType="assessment"
              getParameters={handleGetParameters}
              onChange={handleParametersChange}
            />
          </div>
        </div>
        <div className={cx(styles.right, styles.assessment)}>
          <p className={styles.message}>modify the parameter, sub parameter and the evaluation criteria to fit your preferences.</p>
          <div className={styles.parameterSettings}>
            <input className={styles.name} placeholder="Parameter Name here..." value={parameter?.name || ""} onChange={() => { }} />
            <div className={styles.weightage}>
              weightage for this assessment:
              <input className={styles.value} type="number" value={parameter?.weightage} onChange={() => { }} />
            </div>
          </div>
          <div className={styles.formView}>
            {(parameter?.parameters || []).map((item, index) => (
              <div key={index} className={styles.field}>
                <div className={styles.wrapper}>
                  <input className={styles.name} placeholder="eg: Rapport building..." value={item.name || ""} onChange={() => { }} />
                  <TextareaAutosize
                    className={styles.input}
                    rows={1}
                    value={item?.criteria || ""}
                    placeholder={'eg: Was the salesperson able to build a rapport based on any common ground like location, experience, passion, interests...'}
                    spellCheck={true}
                    onChange={() => { }}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                </div>
                <button className={styles.deleteButton} onClick={() => handleDeleteSubParameter(item)}>
                  <i className="paperflite-delete" />
                </button>
              </div>
            ))}
          </div>
          <div className={styles.actions}>
            <Button variant="gradient" className={styles.addButton} icon="paperflite-add" text="add new sub parameter" onClick={handleAddSubParameter}/>
          </div>
        </div>
      </div>
    </div>
  );
}